import { updateSchedule } from '@/redux/requests/schedulesRequests.js';
import { updateTrigger } from '@/redux/requests/triggersRequests.js';
import { updateWorkflow } from '@/redux/requests/workflowsRequests.js';

/** Turns an automation on or off through the request of its kind. Resolves to the request's result. */
const setAutomationActive = ({ kind, id, active }) => {
  if (kind === 'schedules') {
    return updateSchedule({ scheduleId: id, active });
  }

  if (kind === 'triggers') {
    return updateTrigger({ triggerId: id, active });
  }

  return updateWorkflow({ workflowId: id, active });
};

export default setAutomationActive;
